import {
  IDashboardItem,
  IV1CacheableDashboardGetParameters,
  v2CacheableDashboardGet,
  IFormattedStaffPick,
  IV1StaffPicksGetParameters,
  v1StaffPicksGet,
} from '@ifit/gateway-wolf-dashboard-service';
import { useQuery, UseQueryResult } from 'react-query';
import { getMsToEndOfDay, FIFTEEN_SECONDS } from '../../util/durations';
import { useDate } from '../selectors/use-date';
import { useDoEnableScaling } from '../selectors/use-do-enable-scaling';
import { useEquipmentType } from '../selectors/use-equipment-type';
import { useIsEmbedded } from '../selectors/use-is-embedded';
import { usePlatform } from '../selectors/use-platform';
import { useLanguage } from '../selectors/use-language';
import { useSoftwareNumber } from '../selectors/use-software-number';
import { useUserType } from '../selectors/use-user-type';
import { isClub } from '../../util/is-club';

export function useMarketingStaffPicks(): UseQueryResult<IDashboardItem[], Error> {
  const softwareNumber = useSoftwareNumber();
  const date = useDate();
  const doEnableScaling = useDoEnableScaling();
  const equipmentType = useEquipmentType();
  const isEmbedded = useIsEmbedded();
  const platform = usePlatform();
  const userType = useUserType();
  const language = useLanguage();

  const parameters: IV1CacheableDashboardGetParameters = {
    softwareNumber: Number(softwareNumber),
    equipmentType,
    platform,
    date,
    userType,
    isClub: isClub(softwareNumber),
    isEmbedded,
    doEnableScaling,
  };

  return useQuery<IDashboardItem[], Error>(
    ['staff-picks-marketing', parameters, language],
    () =>
      v2CacheableDashboardGet({
        ...parameters,
        useBasicAuth: true,
        useGatewayCache: true,
        headers: { language },
      }).then((r) => {
        return r.items.filter((item) => item.type === 'marketing');
      }),
    { staleTime: FIFTEEN_SECONDS, cacheTime: getMsToEndOfDay() }
  );
}

export function useStaffPicks(): UseQueryResult<IFormattedStaffPick[], Error> {
  const startingDate = useDate();
  const softwareNumber = useSoftwareNumber();
  const userType = useUserType();
  const language = useLanguage();

  const parameters: IV1StaffPicksGetParameters = {
    softwareNumber: Number(softwareNumber),
    startingDate,
    userType,
  };

  return useQuery<IFormattedStaffPick[], Error>(
    ['staff-picks', parameters, language],
    () => v1StaffPicksGet({ ...parameters, useBasicAuth: true, useGatewayCache: true, headers: { language } }),
    { staleTime: FIFTEEN_SECONDS, cacheTime: getMsToEndOfDay() }
  );
}
